import { defineStore } from 'pinia'
import { useWebSocket } from '@/utils/websocket'
import type { WsMessage } from '@/utils/websocket'
import { WebSocketEvent } from '@/types/constantsEnum'
import { CommonUtils } from '@/utils'
import { useUserStoreHook } from '@/store/modules/user'
export const useWebSocketStore = defineStore('websocket', () => {
  const userStore = useUserStoreHook()
  const { send, onMessageType, close, isConnected } = useWebSocket()

  if (userStore.isLogin) {
    setTimeout(() => {
      send(CommonUtils.sendEventSocket(WebSocketEvent.UserEvent))
    }, 1000)
  } else {
    send({
      event: WebSocketEvent.Ping,
      data: {},
    })
  }
  // 存储所有消息处理器
  const messageHandlers = new Map<string, Set<(data: any) => void>>()

  // 添加消息监听器
  function addMessageListener(type: string, handler: (data: any) => void) {
    if (!messageHandlers.has(type)) {
      messageHandlers.set(type, new Set())
      // 只在第一次添加该类型的处理器时设置监听
      onMessageType(type, (data) => {
        // 打印接收到的消息
        if (type !== WebSocketEvent.Ping) {
          // console.log('🔵 Store收到消息:', {
          //   type,
          //   data,
          //   handlers: messageHandlers.get(type)?.size || 0,
          // })
        }
        // 直接调用处理器处理消息
        messageHandlers.get(type)?.forEach((h) => h(data))
      })
    }
    messageHandlers.get(type)?.add(handler)
  }

  // 移除消息监听器
  function removeMessageListener(type: string, handler: (data: any) => void) {
    messageHandlers.get(type)?.delete(handler)
  }

  // 发送消息
  function sendMessage(message: WsMessage) {
    // 打印发送的消息
    if (message.event !== WebSocketEvent.Ping) {
      console.log('🟡 Store发送消息:', {
        event: message.event,
        data: message.data,
      })
    }
    send(message)
  }

  // 关闭连接
  function closeConnection() {
    close()
  }

  return {
    addMessageListener,
    removeMessageListener,
    sendMessage,
    closeConnection,
    isConnected,
  }
})
